import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SHOW_CLAIM_GROUP_TASKS } from '@rd-web-markets/market/dist/constants';
import { getDashboardLink } from './getDashboardLink';
import TaskTimeline from '@rd-web-markets/shared/dist/claim/TaskTimeline';
import NestedTasksTable from '@rd-web-markets/shared/dist/claim/NestedTaskTable';
import StatBlock from './StatBlock'

const AYMING_BLUE       = '#00aeef';
const AYMING_BLUE_LIGHT = '#E6F1FB';
const AYMING_BLUE_DARK  = '#0C447C';

const ClaimGroupListForCompanyOverview = ({ claimGroups, loading, accountType, company, markTaskComplete }) => {
  const { t } = useTranslation();
  const [selectedTaskIndices, setSelectedTaskIndices] = useState({});

  const selectTask = useCallback((claimGroupId, index) => {
    setSelectedTaskIndices(prev => ({
      ...prev,
      [claimGroupId]: prev[claimGroupId] === index ? null : index,
    }));
  }, []);

  const getActiveIndex = (tasks) => {
    const inProgress = tasks.findIndex(t => t.status === 'in_progress');
    if (inProgress !== -1) return inProgress;
    const notStarted = tasks.findIndex(t => t.status === 'not_started');
    return notStarted !== -1 ? notStarted : tasks.length - 1;
  };

  return (
    <>
      {claimGroups.map((claimGroup) => {
        const hasTasks     = SHOW_CLAIM_GROUP_TASKS && claimGroup.tasks?.length > 0;
        const activeIndex  = hasTasks ? getActiveIndex(claimGroup.tasks) : -1;
        const selectedIndex = selectedTaskIndices[claimGroup.id] ?? null;
        const selectedTask  = selectedIndex !== null ? claimGroup.tasks[selectedIndex] : null;

        return (
          <Card
            key={claimGroup.id}
            className='claim-group-list-card mb-3'
            style={{ padding: '1.25rem 1.5rem', border: '0.5px solid #DBEAFE', borderRadius: '12px' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.25rem' }}>
              <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 500, color: '#111827' }}>
                {claimGroup.name}
              </h3>
            </div>

            {hasTasks && (
              <TaskTimeline
                tasks={claimGroup.tasks}
                activeIndex={activeIndex}
                selectedIndex={selectedIndex}
                onSelectTask={(index) => selectTask(claimGroup.id, index)}
                t={t}
              />
            )}

            {hasTasks && selectedTask && (
              <div style={{ marginBottom: '1.25rem' }}>
                <NestedTasksTable
                  task={selectedTask}
                  claimGroup={claimGroup}
                  selectedIndex={selectedIndex}
                  markTaskComplete={markTaskComplete}
                  t={t}
                />
              </div>
            )}

            <div style={{ display: 'flex', alignItems: 'stretch', gap: '12px' }}>
              <StatBlock icon="folder"       value={claimGroup.projects_count}        label={t('total_projects')        || 'Total projects'} />
              <StatBlock icon="description"  value={claimGroup.in_progress_projects_count} label={t('in_progress_projects') || 'In-progress projects'} />
              <StatBlock icon="attach_money" value={claimGroup.cost_collected_count} label={t('cost_collected')        || 'Cost collected'} />

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '10px', paddingLeft: '8px', flexShrink: 0 }}>
                <Link
                  to={`/${accountType}/companies/${claimGroup.company_id}/${claimGroup.id}/master`}
                  style={{
                    background: AYMING_BLUE, color: '#fff', border: 'none',
                    borderRadius: '24px', padding: '10px 22px',
                    fontSize: '14px', fontWeight: 500,
                    display: 'flex', alignItems: 'center', gap: '6px',
                    whiteSpace: 'nowrap', textDecoration: 'none',
                  }}
                >
                  {t('view_claim') || 'View claim'}
                  <span className="material-icons" style={{ fontSize: '16px' }}>arrow_forward</span>
                </Link>
                <Link
                  to={getDashboardLink(company, accountType, claimGroup)}
                  style={{
                    background: '#fff', color: AYMING_BLUE,
                    border: `2px solid ${AYMING_BLUE}`,
                    borderRadius: '24px', padding: '10px 22px',
                    fontSize: '14px', fontWeight: 500,
                    display: 'flex', alignItems: 'center', gap: '6px',
                    whiteSpace: 'nowrap', textDecoration: 'none',
                  }}
                >
                  {t('dashboard') || 'Dashboard'}
                  <span className="material-icons" style={{ fontSize: '16px' }}>arrow_forward</span>
                </Link>
              </div>
            </div>
          </Card>
        );
      })}
    </>
  );
};

export default ClaimGroupListForCompanyOverview;
